/*
//-------------------------------------------------------
//   Copyright (c) 2019 Templa Computer Systems Ltd
//
//   App:        EmployeePortal.UI
//   Object:     MyDetails
//   Details:    My details page
//
// Log      Date   By  Scan Description
// -----  -------- --- ---- ------------------------------
// 101886 24/06/19 JHT M01  Added image upload
// 103839 06/04/20 JC  M02  React upgrade
// 108107 29/05/20 JC  M03  Don't preview file if not of accepted type, pushed a lot of logic into store
// 110638 11/02/21 JC  M04  React-upgrade
//-------------------------------------------------------
*/

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Col, Row } from 'react-bootstrap';
import { detailsActions } from '../store/MyDetails';
import Loading from '../components/Loading';
import AlertPanel from '../components/AlertPanel';
import DetailField from '../components/DetailField';
import DetailButtons from '../components/DetailButtons';
import Header from '../components/Header';
import NoItems from '../components/NoItems';
//M02 import { systemControlActions } from '../store/SystemControl';

class MyDetails extends Component {
	constructor(props) {
		super(props);

        //M03 removed
		//this.state = {
		//	editing: false,
  //          changedFields: {},
  //          isBlockSave: false,
  //          imageFile: null
  //      }; //M01 added imageFile and isBlockSave

		this.handleFieldChanged = this.handleFieldChanged.bind(this);
		this.handleEdit = this.handleEdit.bind(this);
		this.handleSave = this.handleSave.bind(this);
        this.handleCancel = this.handleCancel.bind(this);

	}

    //M02 componentWillMount
    componentDidMount() {
		// This method runs when the component is first added to the page
		this.props.get();
	}

    //M01
	//componentWillReceiveProps(nextProps) {
	//	// This method runs when incoming props (e.g., route params) change
	//	this.props.get();
 //   }

    //M01
    //static getDerivedStateFromProps(props, state) {
    //    props.get();

    //    // Return null to indicate no change to state.
    //    return null;
    //}

    // --------------------------------------------------------------
    // field change handler
    handleFieldChanged = item => {
  //      // get list of changes from state
		//var changedFields = this.state.changedFields;

  //      if (item.isChanged) {
  //          // if changed, update list with changed item
		//	changedFields[item.key] = { value: item.value, dataType: item.dataType, requiresImageOnChange: item.requiresImageOnChange }; //M01
		//}
		//else if (changedFields.hasOwnProperty(item.key)) {
  //          // if item not changed, delete from list
		//	delete changedFields[item.key];
  //      }
  //      // apply list back to state
  //      this.setState({ changedFields });

        //M03 pass to store to update
        this.props.updateChangedField(item);
	}

    // --------------------------------------------------------------
    // 'edit' button handler (begin editing)
	handleEdit = event => {
        event.preventDefault();

        //M01 store 'image requirement' in state for later reference
        // not now needed, as the image requirement now returned from API
        //var sysCtrl = systemControlActions.getLocal(); 
        //this.setState({ changeImageRequired: sysCtrl.changeImageRequired });

		//M03 this.setState({ editing: true });
        this.props.setEdit(); //M03
	}

    // --------------------------------------------------------------
    // save handler
	handleSave = event => {
        event.preventDefault();
  //      // if any changes in state, force save 
  //      if (this.state.changedFields.length !== 0) { 
  //          //M01 this.props.save(this.state.changedFields);
  //          this.props.save(); //M01
		//}
  //      this.setState({ editing: false, changedFields: {}, imageFile: null }); //M01

        this.props.save(); //M03
	}

    // --------------------------------------------------------------
    // cancel handler
	handleCancel = event => {
		event.preventDefault();
        //M03 this.setState({ editing: false, changedFields: {}, imageFile: null}); 
        //M01 clear selected file
        //M02 this.setState({ imageFile: null });
		//M03 this.props.get();
        this.props.cancelEdit(true) //M03
    }

    // --------------------------------------------------------------
    //M01 change of selected file
    handleImageFileChange = event => {
        //if (event.target.files.length !== 0) {
        //    // get local URL for the image preview
        //    this.setState({ imageFile: URL.createObjectURL(event.target.files[0]) });

        //    // put image contents into the changedFields (in state)
        //    // ... get the changedfields from state, and append with the image path
        //    var changedFields = this.state.changedFields;
        //    // ... read the image 
        //    var fileToRead = event.target.files[0];
        //    var reader = new FileReader();
        //    reader.onloadend = function () {
        //        changedFields["~EPChange~image"] = { value: reader.result, dataType: "1", requiresImageOnChange: false}; 
        //    };
        //    reader.readAsDataURL(fileToRead);

        //    // ... return changedFields to state
        //    this.setState({ changedFields: changedFields }); 
        //} else {
        //    this.setState({ imageFile: null});
        //}

        //M03 if there's a file
        if (event.target.files.length !== 0) {

            //get the file
            var fileToRead = event.target.files[0];

            //M03 pass file to store
            this.props.setImageFile(fileToRead);

            //get a ref to the props to get round ref image in reader onloadend
            var localProps = this.props;

            // ... read the image 
            var reader = new FileReader();
            reader.onloadend = function () {
                //M03 pass to store
                localProps.setImageFile_StoreLoadedFile(reader.result);
            };

            //read as data URL
            reader.readAsDataURL(fileToRead);

        } else {
            //M03 pass to store
            this.props.setImageFile_NoFileSelected();
        }
    }

    // --------------------------------------------------------------
    //M01 clear selected file
    handleImageFileClear = event => {
        //M03 this.setState({ imageFile: null });
        this.props.clearImageFile(); //M03
    }

    // --------------------------------------------------------------
    //M01 check image requirement
    checkImageRequired() {
        // skip if not editing, or we have a file upload selected
        if (this.props.editing && this.props.imageFile === null) //M03
        {
            var changedFields = this.props.changedFields; //M03
            var isImageRequired = false;
            // check the changed fields for any that require an image on change
            Object.values(changedFields).forEach(function (value) {
                isImageRequired = isImageRequired || value.requiresImageOnChange;
            });

            return isImageRequired;
        }
        
        return false;
    }

    // --------------------------------------------------------------
    //M01 check image exists
    hasImage() {
        return this.props.imageFile !== null;
    }

    // --------------------------------------------------------------
    // Render
	render() {
        const { error, fields, isLoading, timestamp, canPreviewFile, editing, imageFile, changedFields, hasSaveError } = this.props; //M02 M03
		let hasChangedDetails = fields.filter((item, i) => {
			return item.isPending;
        }).length !== 0;
        
        return (
            <div>
                <Header title="My Details" />

                {/*M01 show relevant buttons, conditioning 'save' to whether image is required*/}
                {fields.length === 0
                    ? ""
                    : <DetailButtons location="top" isLoading={isLoading} isBlockSave={this.checkImageRequired()}
                        editing={editing} edit={this.handleEdit} save={this.handleSave} cancel={this.handleCancel} /> /*M03*/
                }

                {error ? <AlertPanel type="danger" message={error} /> : []}
                {hasChangedDetails ? <AlertPanel type="pending" message="Some of your details are not yet approved." /> : []}


                {isLoading ? <Loading /> : []}
                {!isLoading && fields.length === 0
                    ? <NoItems />
                    : <div>
                        {/*M01 render alert if image is required*/}
                        {this.checkImageRequired()
                            ? <AlertPanel type="danger" message="You must upload a document for this change" />
                            : []
                        }
                        {/*show a row for each detail item*/}
                        {fields.map((item, i) => {

                            /* M03 get the item, passing the value into a new original value field */
                            let localItem = { ...item, originalValue: item.value };

                            /* M03 if there's a changed field for the key then use this for the value instead */
                            if (localItem.key in changedFields) {
                                localItem = { ...localItem, value: changedFields[localItem.key].value };
                            }

                            return (
                                <Row key={localItem.key}>
                                    <Col sm={3}>
                                        <label>{localItem.label}</label>
                                    </Col>
                                    <Col sm={9}>
                                        <DetailField item={localItem}
                                            editing={editing}  /*M03*/
                                            changed={this.handleFieldChanged}
                                            timestamp={timestamp} /* M02 pass last refresh timestamp */
                                        />
                                    </Col>
                                </Row>
                            );
                        })}

                        {/*M01 render alert if image is required*/}
                        {this.checkImageRequired()
                            ? <AlertPanel type="danger" message="You must upload a document for this change" />
                            : []
                        }

                        {/*M03 repeat error at bottom of page if changed details exist M03 or there's a save error */
                            error && (hasChangedDetails || hasSaveError) ? <AlertPanel type="danger" message={error} /> : []}

                        {/*M01 when editing, show file select and preview*/}
                        {editing ?  /*M03*/
                            <div>
                                {this.hasImage() ?
                                    <div>
                                        <button className="btn btn-default" onClick={this.handleImageFileClear} >Clear</button>
                                        <br />
                                        {/* M03 file type allows preview? */}
                                        {canPreviewFile ?
                                            <img className="image-preview" src={imageFile} /> /* M03 */
                                            :
                                            <label>File selected</label>
                                        }
                                    </div>
                                    :
                                    <div>
                                        <input type="file"
                                            className="custom-file-input"
                                            id="file"
                                            accept=".gif, .jpg, .png, .pdf"
                                            onChange={this.handleImageFileChange} /> {/* M03 was  accept="image/*"*/}
                                        <label className="btn btn-default" htmlFor="file">Choose file</label> {/* M01 replaced custom-file-label with btn btn-default in className*/}
                                    </div>
                                }
                                </div>
                        :[]}
                    </div>

				}

                {/*M01 show relevant buttons, conditioning 'save' to whether image is required*/}
                {fields.length === 0
					? ""
                    : <DetailButtons location="bottom" isLoading={isLoading} isBlockSave={this.checkImageRequired()}
                        editing={editing} edit={this.handleEdit} save={this.handleSave} cancel={this.handleCancel} /> /*M03*/
				}
			</div>
		);
	}
}

MyDetails.propTypes = {
	error: PropTypes.string,
	fields: PropTypes.arrayOf(PropTypes.any),
	isLoading: PropTypes.bool.isRequired
};

export default connect(
	state => state.myDetails,
	dispatch => bindActionCreators(detailsActions, dispatch)
)(MyDetails);
